/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AnnualClockMonth } from './AnnualClockMonth';
import {
    AnnualClockMonthFromJSON,
    AnnualClockMonthToJSON,
} from './AnnualClockMonth';

/**
 * Represents a quarter in the annual clock
 * @export
 * @interface AnnualClockQuarter
 */
export interface AnnualClockQuarter {
    /**
     *
     * @type {string}
     * @memberof AnnualClockQuarter
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockQuarter
     */
    quarter: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockQuarter
     */
    description: string;
    /**
     *
     * @type {Array<AnnualClockMonth>}
     * @memberof AnnualClockQuarter
     */
    months: AnnualClockMonth[];
}

/**
 * Check if a given object implements the AnnualClockQuarter interface.
 */
export function instanceOfAnnualClockQuarter(value: object): value is AnnualClockQuarter {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('quarter' in value) || value['quarter'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('months' in value) || value['months'] === undefined) return false;
    return true;
}

export function AnnualClockQuarterFromJSON(json: any): AnnualClockQuarter {
    return AnnualClockQuarterFromJSONTyped(json, false);
}

export function AnnualClockQuarterFromJSONTyped(json: any, _: boolean): AnnualClockQuarter {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'quarter': json['quarter'],
        'description': json['description'],
        'months': ((json['months'] as any[]).map(AnnualClockMonthFromJSON)),
    };
}

export function AnnualClockQuarterToJSON(json: any): AnnualClockQuarter {
    return AnnualClockQuarterToJSONTyped(json, false);
}

export function AnnualClockQuarterToJSONTyped(value?: AnnualClockQuarter | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'quarter': value['quarter'],
        'description': value['description'],
        'months': ((value['months'] as any[]).map(AnnualClockMonthToJSON)),
    };
}
